import IndexContainer from "./containers/index.container";

const routes = [
  {
    path: "/",
    component: IndexContainer
  }
];

export default routes;
